import { Campaign, CreateCampaign } from './../../_shared/models/campaign.model';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CreateCampaignService {
  private http = inject(HttpClient);

  create(form: CreateCampaign): Observable<Campaign> {
    return this.http.post<{data: { campaign: Campaign} }>('api_endpoint' + '/campaign/create', { form }).pipe(
      map(res => res.data.campaign)
    );
  }
}
